module.exports = __webpack_public_path__ + "media/images/main_search_sp-0e4c4ce60c342a39a927a56dc7f128d7.png";